import React from 'react'
import { useCurrentYear } from 'hooks/useCurrentYear'

import styles from './privacyContent.module.scss'

const PrivacyContent = () => {
  return (
    <main className={styles.privacyContent}>
      <section className={styles.privacyPolicy}>
        <h1 id="privacy-policy">Privacy policy</h1>
        <p>Last updates on August 1st, {useCurrentYear()}</p>
        <p>
          Discount-fares.com (Discount Fares, “we”, “us”, “our”, “website”) respects your privacy!
          We adhere to the highest industry standards for the protection of your personal
          information (PI/ personal data). When you use the website, you agree to the terms in this
          policy. This policy applies to PI processed while you are visiting our website. By using
          our website, you acknowledge that we process your PI in accordance with this privacy
          policy. This policy may be amended from time to time. Please follow this page to access
          the most actual version of policy. If the privacy policy changes materially we will notify
          you.
        </p>
      </section>
      <section>
        <h2 id="categories-of-personal-information">Categories of personal information</h2>
        <p>
          We are collecting different categories of data based on your relationships with us,
          requirements of applicable legislation and our business interests conducting our business.
          We do not collect any special categories of personal data about you (this includes details
          about your race or ethnicity, religious or philosophical beliefs, sex life, sexual
          orientation, political opinions, trade union membership, information about your health,
          and genetic and biometric data). Nor do we collect any information about criminal
          convictions and offences. We do not knowingly collect personal data from/ about known
          child.
        </p>
        <p>Below is the list of categories of PI we might collect:</p>
        <ul>
          <li>
            Identifiers. For example, a name, unique personal identifier (cookie), online identifier
            Internet Protocol address or other similar identifiers
          </li>
          <li>Contacts. For example, an email address and a telephone number.</li>
          <li>General Geo data (country or state or city).</li>
          <li>
            Network Data. For example, your login data, browser type and version, browsing history,
            search history, time zone setting and location, browser plug-in types and versions,
            operating system and website, and other technology on the devices you use to access our
            website).
          </li>
          <li>Communication. For example, call records and email threads</li>
          <li>
            Profile data. For example, inferences about your marketing preferences, behavior and
            deidentified data.
          </li>
        </ul>
        <p>
          We might collect, use and share deidentified data such as statistical or demographic data
          for any purpose. This data could be derived from your PI, but is not considered PI in law,
          as deidentified data will not directly or indirectly reveal your identity.
        </p>
        <p>
          We take reasonable measures to ensure the data cannot be associated with you. We maintain
          and use deidentified data without attempting to re-identify the data. For example, we may
          aggregate your Network data to calculate the percentage of users accessing a specific
          website feature.
        </p>
      </section>
      <section>
        <h2 id="purpose-for-collection-use">Purposes for collection/use</h2>
        <p>Purposes for collection/use</p>
        <ul>
          <li>assistance in finding the best possible prices for flights</li>
          <li>connecting clients with partners, who might satisfy</li>
          <li>customer support and replying to your request</li>
          <li>complying with laws</li>
          <li>legal claim protection</li>
          <li>repairing technical errors</li>
          <li>responding to incidents</li>
          <li>Fraud prevention</li>
        </ul>
        <p>
          Our main processing activity starts only upon your request: if you ask to provide the
          price quote (Service). Rendering Services you will share the itinerary, dates and contact
          information. Our partners might contact you to make an even better deal. If you disagree
          we value your privacy! It means you can opt-out from any communication any time by
          contacting us.
        </p>
        <p>
          We might also process metadata and electronic identifiers to maintain our systems,
          prevent/ fix bugs (errors) and protect our network.
        </p>
      </section>
      <section>
        <h2 id="sources-of-personal-information">Sources of personal information</h2>
        <p>The majority cases PI is being collected directly from you, when you:</p>
        <ul>
          <li>interacting with our website</li>
          <li>completing the form</li>
          <li>contacting us via phone or email</li>
        </ul>
      </section>
      <section>
        <h2 id="categories-of-information-shared-with-third-parties-and-categories-of-3rd-parties">
          Categories of information shared with third parties and categories of 3rd parties
        </h2>
        <p>
          Generally, we do not share your data with third parties, except you guided us to do so.
          The only way we are doing so, when it aligns with the processing purpose set in this
          policy. Disclosing your PI, we require recipients to follow applicable legislation and
          data protection measures when they process your PI.
        </p>
        <p>
          Our website may contain links to third-party websites, products and services. When you use
          a third-party service or click a link to a third-party website, our policy is not
          applicable. Please, contact the relevant third party to obtain their privacy rules.
        </p>
        <p>
          Depending on processing purposes, we might share your data with our associated companies,
          our services and goods suppliers, as well as other third parties. For more detailed
          information, please kindly refer to the list below:
        </p>
        <ul>
          <li>
            Affiliates and associated companies: for organizing internal workflow, enhance our
            efficiency, provide and improve our services, website’s content and make our advertising
            more convenient and better matching your expectations. We may share your data in case of
            change of control/owners of website.
          </li>
          <li>Service providers: payment service providers, IT support and travel vendors.</li>
          <li>
            Business partners: for fraud prevention, creating a survey, for online behavioral
            advertising purposes, or to offer you services or products that we believe you may be
            interested in.
          </li>
          <li>
            Public data: if you authorize us to publish your review of your trip and in other
            specific cases.
          </li>
          <li>
            Regulators, law enforcement: we may disclose PI if required by applicable legislation,
            for example to law enforcement or other authorities
          </li>
        </ul>
      </section>
      <section>
        <h2 id="how-to-exercise-consumer-rights-appeal-right-contacts">
          How to exercise consumer rights, appeal rights, contacts
        </h2>
        <p>
          We honour your rights available under applicable legislation. In case we are only a
          service provider and transfer PI to our partners, we will not be the one responding to
          your requests; in this case we will do our best to connect you with our partners. Your
          rights shall neither adversely affect the rights and freedoms of others, nor affect our
          trade secrets.
        </p>
        <p>
          Our main communication channel for submitting requests is an email address used initially
          to receive our services (Verified email).
        </p>
        <p>
          You can submit your requests and other questions about your privacy by contacting us{' '}
          <a href="/#contacts">HERE</a>. Generally, we answer within 45 days. This period may be
          extended by 45 days where necessary, considering the complexity and number of requests.
        </p>
        <p>
          In case requests are manifestly unfounded or excessive (more than 2 requests annually), we
          might refuse to act on the request explaining reasons or you might be charged a fee. In
          case we have reasonable doubts concerning your identity (also authorized agent), we may
          request yout to clarify and verify some details. provision of additional information
          necessary to confirm the identity.
        </p>
        <p>
          If you disagree with our response, you are entitled to appeal by submitting the email to
          us within 30 days after our response. The appeal must contain “Appeal of request” wording.
          We will reply within 45 days. Otherwise, you are entitled to lodge a complaint with data
          protection authorities in accordance with applicable legislation.
        </p>
      </section>
      <section>
        <h2 id="cookies">Cookies</h2>
        <p>
          Cookies and other similar technologies are small text files stored on your device for one
          session or longer (if necessary). These can be removed by following Internet browser help
          file directions. If you reject cookies, you may still use the website, but might
          experience some inconvenience and some functions won’t be available.
        </p>
      </section>
      <section>
        <h2 id="third-party-cookies">Third-Party cookies</h2>
        <p>
          We may use advertising partners to serve ads. The partners may collect and use
          information, including third party cookies, about your visits to our website and other
          websites in order to provide advertisements about goods and services that may be of
          interest to you. Third party cookies can be removed, for example, by following
          instructions at{' '}
          <a href="https://cookies.insites.com/disable-cookies/">
            https://cookies.insites.com/disable-cookies/
          </a>
        </p>
      </section>
    </main>
  )
}

export { PrivacyContent }
